__webpack_require__.p = "/fronts/manager-onep-shared-info";